// fetchAndPrependMessageId.js
'use strict';
import { ADD_LIST_ITEMS } from '../ActionTypes.js';

import fetchFeeds from '../action/fetchFeeds.js';

import getListData from '../selector/getListData.js';

/**
 * Fetch feed and prepend message id
 * @kind action
 * @param {string} {messageId} - message id.
 * @param {string} {category} - category name.
 * @return {Promise} Action promise.
 */
const fetchAndPrependMessageId =
  ({ messageId, category } = {}) =>
  async (dispatch, getState) => {
    const listSelectPath = ['shorts', category];
    const prependIds = [];
    if (messageId) {
      prependIds.push(messageId);
    }
    await dispatch(
      fetchFeeds({
        type: category,
        isAllowSameId: true,
        shouldReplaceIds: true,
        shouldIgnorePage: true,
        shouldSkipLocalCache: true,
        selectPath: listSelectPath,
        prependIds,
      })
    );
    const itemIds = getListData(getState(), listSelectPath, 'itemIds') || [];
    // Insert message id into short ids if list still empty.
    if (messageId && itemIds.length === 0) {
      return dispatch({
        type: ADD_LIST_ITEMS,
        payload: {
          selectPath: listSelectPath,
          itemIds: [messageId],
        },
      });
    }
  };

export default fetchAndPrependMessageId;
